<template>
  <v-form ref="form" style="width: 100%;">
    <v-row>
        <template v-for="(section) in sections">
          <template v-for="field in section.fields">
              <Field
                v-if="field.alias != 'status'"
                :ref="`field-${field.alias}`"
                :key="field.sequence"
                :eventBus="eventBus"
                :expressionInterpreter="expressionInterpreter.interpreter(field.alias)"
                :label="field.name"
                :required="field.required"
                :alias="field.alias"
                :type="field.type.name"
                :config="field.config"
                :params="field.params"
                :dependency="field.dependency"
                :disabled="lock"
                :sections="sections"
                :changeOptions="() => submit('buscar')"
              ></Field>

          </template>
        </template>
    </v-row>
  </v-form>
</template>

<script>
import Field, { FIELD_TYPES, EXTENDED_FIELD_TYPES } from './Field.vue';
import FormExpressionInterpreter from './form-expression-interpreter';

const INPUT_TYPES = Object.values(FIELD_TYPES)
  .concat( // extend valid input types with custom extended field types
    Object.values(EXTENDED_FIELD_TYPES)
      .map((extendedFieldTypeEntry) => extendedFieldTypeEntry[1]),
  );

export default {
  props: {
    id: String,
    data: {
      type: Object,
      required: true,
    },
    lock: {
      type: Boolean,
      default: () => false,
    },
    profileViewForm: {
      type: Boolean,
      default: () => false,
    },
    buttons: {
      type: Array,
      default: () => [],
    },
    filterStatus: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    Field,
  },
  data({ id, data }) {
    return {
      sections: data.properties.reduce((tot, curr) => {
        const currSection = tot.length ? tot[tot.length - 1] : null;
        if (typeof (curr.config || {}).section === 'string') {
          // field section configured
          if (currSection != null && currSection.section === curr.config.section) {
            currSection.fields.push(curr);
          } else {
            tot.push({ section: curr.config.section, fields: [curr] });
          }
        } else if (currSection != null && currSection.section == null) {
          currSection.fields.push(curr);
        } else {
          tot.push({ fields: [curr] });
        }

        return tot;
      }, []),
      eventBus: this.$events.create(`form-${id}`),
      expressionInterpreter: new FormExpressionInterpreter({
        staticContextFields: {
          element: data,
          user: this.$store.getters['session/user'],
        },
        getFieldsCtx: this.getFieldsCtx,
      }),
      elementForInsert: [],
    };
  },
  computed: {
    isDesktop() {
      const desktop = window.matchMedia('screen and (min-width: 960px)');
      return desktop.matches;
    },
  },
  methods: {
    getFieldsCtx() {
      const $form = this.$children[0];
      const inputChildren = $form.$children
        .filter((child) => INPUT_TYPES.includes(child.component));

      return inputChildren.reduce((tot, curr) => {
        // eslint-disable-next-line no-param-reassign
        tot[curr.alias] = curr.fieldValue;
        return tot;
      }, {});
    },
    getFormData() {
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined' && entry[1].value !== null && entry[1].value !== '')
          .map((entry) => [entry[0], entry[1].value]),
      );
    },
    getFormDataAll() {
      return Object.fromEntries(
        Object.entries(this.expressionInterpreter.fieldsContext)
          .filter((entry) => typeof entry[1].value !== 'undefined' && entry[1].value !== null && entry[1].value !== ''),
      );
    },
    async submit(submitBtn) {
      const formData = this.getFormData();

      // adding not visible fields with submit to true to form data
      this.data.properties
        .filter((p) => String((p.config || {}).submit) === 'true' && String((p.dependency || {}).visibility) === 'false')
        .flatMap((p) => this.$refs[`field-${p.alias}`])
        .filter((p) => p.fieldData.initialValue != null)
        .forEach((p) => {
          formData[p.alias] = p.fieldData.initialValue;
        });

      this.data.properties.forEach((item) => {
        const t = formData[item.alias];
        if (item?.special_values && Object.keys(item?.special_values).length > 1) {
          const { special_values: specialValue } = item;
          if (specialValue && specialValue?.integrationid && specialValue?.integrationname) {
            if (
              t
              && t[item.special_values.integrationid] === t[item.special_values.integrationname]
            ) {
              t.id = this.$refs[`field-${item.alias}`][0].fieldValue.item.id;
              t.value = this.$refs[`field-${item.alias}`][0].fieldValue.value.value;
            }
          }
        }
      });

      console.log('submit formdate', { formData, submitBtn, filters: this.filterStatus });
      this.$emit('click:submit', {
        action: submitBtn,
        data: {
          open_date: formData.open_date,
          resolve_date: formData.resolve_date,
          status: this.filterStatus,
        },
      });

      return true;
    },
  },
  beforeDestroy() {
    this.$events.destroy(`form-${this.id}`);
  },
  created() {
    const elementForInsertLocalStorage = localStorage.getItem('elementForInsert');
    if (elementForInsertLocalStorage && elementForInsertLocalStorage.length > 0) {
      this.elementForInsert = JSON.parse(elementForInsertLocalStorage);
    } else {
      this.elementForInsert = [];
    }

    if (this.$props.profileViewForm !== true) {
      this.eventBus.on('form:disableSubmit', (disableSubmit) => {
        this.$props.submitVisible = !disableSubmit;
      });

      this.eventBus.on('form:change', (data) => {
        const dataFormAll = this.getFormDataAll();
        const dataChange = {
          dataForm: dataFormAll,
          alias: data.alias,
        };
        setTimeout(() => {
          this.$root.$emit('UpdateFiledForm', dataChange);
        }, 1000);
        // this.$root.$emit('UpdateFiledForm', dataChange);
      });
    }
    this.$root.$on('formDisabledBtn', (data) => {
      this.btnDisabled = data;
    });
  },
};
</script>

<style lang="scss" scoped>
  .linebreak {
    height: 0;
  }
  .section--divider, .linebreak {
    flex-basis: 100%;
  }
  a {
    text-decoration: none;
  }

  @media (min-width: 960px) {
    .botonera__form {
      padding-right: 130px !important;
    }
  }
</style>
